import { Popup } from '../../../hexagon/models/PopupModel';
import { AppState, FetchStatus } from '../../../redux/appState';

export interface PopupVM {
    status: FetchStatus;
    data: Popup;
    exists: boolean;
}

export const getPopupSelector = (state: AppState): PopupVM => ({
    status: state.popup.status,
    data: state.popup.data,
    exists: Object.keys(state.popup.data).length !== 0,
});
